import { ArrowRight } from "lucide-react";

export default function Founder({ data }) {
  const label = data?.label || "A note from the founder";
  const headline = data?.headline || "Hi, I'm Romario.";
  const paragraphs = data?.paragraphs || [];
  const cta = data?.cta || { label: "Let's Talk About Your Wedding", href: "#contact" };
  const image = data?.image_url;
  const name = data?.name || "Romario";

  return (
    <section id="founder" data-testid="founder-section" className="bg-ivory py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-14 items-center">
          {/* Image */}
          <div className="col-span-12 md:col-span-5">
            <div className="reveal relative">
              <div className="img-zoom-wrap aspect-[4/5] w-full bg-sage/50 border border-beige">
                {image ? (
                  <img
                    src={image}
                    alt={name}
                    data-testid="founder-image"
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                ) : (
                  <FounderSilhouette />
                )}
              </div>
              <div className="absolute -bottom-4 -right-2 md:-bottom-6 md:-right-6 bg-charcoal text-ivory px-5 py-3 md:px-7 md:py-4">
                <div className="font-display text-lg md:text-xl">{name}</div>
                <div className="uppercase tracking-[0.25em] text-[9px] md:text-[10px] text-ivory/60 mt-0.5">
                  Founder · Mostash
                </div>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="col-span-12 md:col-span-7 md:pl-6">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-gold" />
              <span className="eyebrow">{label}</span>
            </div>
            <h2
              data-testid="founder-headline"
              className="reveal font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-charcoal"
            >
              {headline}
            </h2>
            <div className="reveal mt-8 space-y-5 text-charcoal/75 font-light leading-relaxed max-w-xl">
              {paragraphs.map((p, i) => (<p key={i}>{p}</p>))}
            </div>
            <a
              href={cta.href}
              data-testid="founder-cta"
              className="reveal mt-10 inline-flex items-center gap-3 group btn-primary"
            >
              {cta.label}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function FounderSilhouette() {
  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-0 bg-gradient-to-b from-sage/60 via-beige/40 to-sage/60" />
      <svg viewBox="0 0 400 500" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 h-full w-full" aria-hidden="true">
        <defs>
          <linearGradient id="silh" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#006D77" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#006D77" stopOpacity="0.5" />
          </linearGradient>
        </defs>
        <ellipse cx="200" cy="170" rx="78" ry="92" fill="url(#silh)" />
        <path d="M60 500 Q60 330 200 320 Q340 330 340 500 Z" fill="url(#silh)" />
      </svg>
      <div className="absolute bottom-4 left-4 right-4 text-center">
        <div className="uppercase tracking-[0.3em] text-[10px] text-charcoal/50">
          Founder image · upload in admin → content → founder
        </div>
      </div>
    </div>
  );
}
